<template>
  <el-dialog
    v-model="dialogVisible"
    width="60%"
    destroy-on-close
  >
    <Container
      :title="t('Acceptance.acceptanceReceiptDetail')"
      :hasLine="true"
    >
      <template #main>
        <el-form
          :label-width="labelWidth"
          ref="cFormRef"
          label-position="right"
          style="margin-left:15%; font-size: 14px;"
        >
          <el-row :gutter="4">
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.draftNo')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.draftNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.requestObject')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.requestObject }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="9">
              <el-form-item
                :label="t('company.companyCode')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.companyCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.requestDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ paymentDateFormat(inputData.requestDate) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.receiveBankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.receiveBankName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.banendFlag')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.banendFlag }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.splitFlag')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.splitFlag }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.requestEntrustPay')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.requestEntrustPay }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.draftType')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.draftType }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.bankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ inputData.bankName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.issueDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ paymentDateFormat(inputData.issueDate) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.draftAmt')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatThousands(inputData.draftAmt) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.dueDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ paymentDateFormat(inputData.dueDate) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                :label="t('Acceptance.usedAmount')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatThousands(inputData.useAmt) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row style="margin-bottom: 5px">
          <el-col
            :span="12"
          >
            <span class="header-title">流转记录</span>
          </el-col>
        </el-row>
        <SimpleTable
          ref="tableRef"
          :listLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :hadSelect="false"
          :had-operate="false"
          :operateColumnWidth="/*$hasPermission(['approvalform_M'])*/ true ? 240:80"
        />
      </template>
    </Container>
  </el-dialog>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import Container from '@/components/form/container/Container.vue'
import { useI18n } from 'vue-i18n'
import { formatDate, formatThousands } from '@/utils'
import {
  PaymentAcceptanceStatementModel,
  PaymentAcceptanceStatementParamModel
} from '@/model/paymentSlip/paymentSlipHistoryModel'
import { getPaymentAcceptanceStatement } from '@/apis/paymentSlip/paymentSlipHistory'

export default defineComponent({
  name: 'AcceptanceDetailDialog',
  methods: { formatThousands },
  props: {
    inputData: {
      type: Object,
      required: true,
      default: null
    },
    labelWidth: {
      type: String,
      default: '680px'
    }
  },
  components: {
    SimpleTable,
    Container
  },
  setup(props) {
    const { t } = useI18n()
    const tableRef = ref()
    const detailTableStruct = [
      { prop: 'behaveNo', label: t('Acceptance.behaveNo') },
      { prop: 'behaveType', label: t('Acceptance.behaveType') },
      { prop: 'behaveDate', label: t('Acceptance.behaveDate'), formatter: (row: any) => formatDate(row.behaveDate, 'yyyyMMdd') },
      { prop: 'requestObject', label: t('Acceptance.requestObjectName') },
      { prop: 'requestBankName', label: t('Acceptance.requestObjectBankName') },
      { prop: 'responseObject', label: t('Acceptance.responseObject') },
      { prop: 'responseBankName', label: t('Acceptance.responseBankName') },
      { prop: 'banendFlag', label: t('Acceptance.banendFlagTrue') },
      { prop: 'signupMark', label: t('Acceptance.signupMark') }
    ]
    const dataMap = reactive({
      tableData: Array<PaymentAcceptanceStatementModel>(),
      columnStruct: detailTableStruct,
      listLoading: true,
      detailData: {},
      showFooterRejectAndProcess: true,
      showFooterRefuseAndSignature: true,
      async getData() {
        dataMap.listLoading = true
        const params: PaymentAcceptanceStatementParamModel = {
          paymentAcceptanceHistoryId: props.inputData.id
        }
        const acceptanceStatementData = await getPaymentAcceptanceStatement(params)
        if (acceptanceStatementData && acceptanceStatementData.data) {
          dataMap.tableData = acceptanceStatementData.data
        }
        // const params: PaymentSlipPageParamModel = {
        //   updatedAtStart: dataMap.searchFormModel.dateRange?.length > 0 ? dataMap.searchFormModel.dateRange[0] : null,
        //   updatedAtEnd: dataMap.searchFormModel.dateRange?.length > 1 ? dataMap.searchFormModel.dateRange[1] : null,
        //   pageCurrent: dataMap.page,
        //   pageSize: dataMap.limit
        // }
        // dataMap.detailData = {
        //   draftNo: '1111111111111',
        //   requestObject: 'xxx材料(常州)有限公司',
        //   companyCode: '100000',
        //   requestDate: '2025-10-28',
        //   receiveBankName: 'xxxx银行xxxx分行',
        //   banendFlag: '',
        //   splitFlag: '',
        //   requestEntrustPay: '',
        //   draftType: '',
        //   bankName: 'xxxx银行xxxx分行',
        //   issueDate: '',
        //   draftAmt: '12304.50',
        //   dueDate: '',
        //   usedAmount: ''
        // }

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      paymentDateFormat(paymentDate: Date): string {
        return formatDate(paymentDate, 'yyyy-MM-dd')
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      tableRef,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style scoped lang="scss">
.header-title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}
</style>
